// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vx42","rootMobile":"styles_rootMobile__2A-Y9"};